<template>
  <div id="print1">
    <!-- {{ optionView }} -->
    <!-- {{this.role}} -->
    <!-- <pre>{{ this.comments }}</pre> -->

    <vs-row id="center">
      <h6>
        {{ viewwork.name }} #<a class="font-weight-bold mr-2">
          {{ viewwork.id }}</a
        ><span
          v-if="
            role == 'admin' &&
            ['Approved', 'Rejected'].includes(viewwork.response)
          "
          ><a style="color: #fd4"
            ><span
              style="vertical-align: middle; font-size: 1.2rem"
              class="material-icons"
            >
              star
            </span></a
          ><a class="ml-1" style="color: #111">{{ ratingValue }}/5</a></span
        >
      </h6>
      <vs-spacer />

      <vs-dropdown vs-trigger-click left>
        <vs-button
          color="rgba(9, 30, 66, 0.04)"
          type="filled"
          icon="share"
          size="small"
          id="btnShare"
          >Share</vs-button
        >
        <vs-dropdown-menu style="width: max-content" class="fontSizeData">
          <vs-dropdown-item @click="printTemplate(viewwork)">
            <vs-icon icon="print" class="mr-1" id="fontIcon"></vs-icon>Print
          </vs-dropdown-item>
          <vs-dropdown-item>
            <vs-icon icon="email" class="mr-1" id="fontIcon"></vs-icon>Send a
            Reminder
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-row>
    <!-- <vs-row id="center"><span><a style="color: #fd4; font-size: 1.3rem">★</a><a class="ml-2" style="color: #111; ">5 </a></span></vs-row> -->
    <div class="container">
      <vs-row class="mt-3" id="center">
        <h6 class="fontSizeData marginTop mr-1" id="center">
          <vs-tooltip
            text="This is the Asset this Task is assigned to."
            position="top"
          >
            <span id="allIcon" class="material-icons mr-1"> grid_view </span>
          </vs-tooltip>
          <span v-for="i in users" :key="i">
            <span class="mr-1 ml-1 aLocation">{{ i.name }}</span> >
          </span>
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip
            text="This is Location this Task is assigned to."
            position="top"
          >
            <span id="allIcon" class="material-icons mr-1"> home </span>
          </vs-tooltip>
          {{ viewwork.asset }}
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip text="Who this Task is assigned to" position="top">
            <span id="allIcon" class="material-icons mr-1"> person </span>
          </vs-tooltip>
          {{ viewwork.username }}
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip text="The Due Date of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> date_range </span>
          </vs-tooltip>
          {{ $moment(viewwork.duedate).format("YYYY-MM-DD HH:mm:ss") }}
        </h6>
        <h6
          v-if="viewwork.priority == '1 - Low priority'"
          class="mr-2 textSuccess fontSizeData marginTop"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ viewwork.priority }}
        </h6>
        <h6
          v-if="viewwork.priority == '2 - Medium priority'"
          class="mr-2 fontSizeData marginTop textWarning"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ viewwork.priority }}
        </h6>
        <h6
          v-if="viewwork.priority == '3 - High priority'"
          class="mr-2 fontSizeData marginTop textDanger"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ viewwork.priority }}
        </h6>
      </vs-row>

      <vs-row
        v-if="viewwork.response == 'Submitted' && role == 'admin'"
        class="mt-3 p-3 notiAcknow"
      >
        <div>
          <h6 class="font-weight-bold textWarning">Task Approval</h6>
          <footer class="blockquote-footer mt-1">Approve or Reject task</footer>
        </div>
        <vs-spacer />

        <vs-button
          size="small"
          @click="rejectTask(viewwork)"
          class="rounded-pill mr-1"
          color="warning"
          type="border"
          >Reject</vs-button
        >
        <vs-button
          size="small"
          @click="approveTask(viewwork)"
          class="rounded-pill"
          color="warning"
          type="filled"
          >Approve</vs-button
        >
        <!-- <vs-button
          size="small"
          @click="signFOrAppoveTask"
          class="rounded-pill"
          color="warning"
          type="filled"
          >Approve</vs-button
        > -->
      </vs-row>
      <vs-row
        v-if="viewwork.response == 'Declined' && role == 'admin'"
        class="mt-3 mb-3 p-3 notiAcknow"
      >
        <div>
          <h6 class="font-weight-bold textWarning">Task Cancel</h6>
          <footer class="blockquote-footer mt-1">Cancel</footer>
        </div>
        <vs-spacer />

        <vs-button
          size="small"
          @click="cancelledTask(viewwork)"
          class="rounded-pill"
          color="warning"
          type="filled"
          >Close</vs-button
        >
      </vs-row>

      <!-- <vs-row class="mt-3 mb-3 p-3 notiApproval"> -->
      <vs-row
        v-if="viewwork.response == 'Created' && role != 'admin'"
        class="mt-3 mb-3 p-3 notiApproval"
      >
        <div>
          <h6 class="font-weight-bold textSuccess">Task Acknowledge</h6>
          <footer class="blockquote-footer mt-1">Acknowledge or Decline</footer>
        </div>
        <vs-spacer />

        <vs-button
          size="small"
          @click="declineTask(viewwork)"
          class="rounded-pill mr-1"
          color="success"
          type="border"
          >Decline</vs-button
        >
        <vs-button
          size="small"
          @click="acknowledgeTask(viewwork)"
          class="rounded-pill"
          color="success"
          type="filled"
          >Acknowledge</vs-button
        >
      </vs-row>

      <vs-row
        v-if="viewwork.response == 'Completed'"
        class="mt-3 mb-3 p-3 notiApproval"
      >
        <div style="display: flex; align-items: center">
          <span>
            <vs-icon icon="event_available" color="primary"></vs-icon>
          </span>
          <h6 class="textSuccess ml-2">
            This Task has been
            <span
              class="font-weight-bold textSuccess"
              style="font-size: 0.875rem"
            >
              completed</span
            >
          </h6>
        </div>
        <vs-spacer />
      </vs-row>

      <h6 class="mt-3 fontSizeData">
        Started By: <a class="boldWeightA"> Admin </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Created Date:
        <a class="boldWeightA">
          {{ $moment(viewwork.timestamp).format("LLLL") }}
        </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Last Edited:
        <a class="boldWeightA">
          {{ $moment(viewwork.editdate).format("LLLL") }}
        </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Time Spent: {{ viewwork.timespent }}
        <!-- <a class="boldWeightA">
          {{ $moment(viewwork.timestamp).format("LLLL") }}
        </a> -->
      </h6>
      <stepbar :viewwork="viewwork" />
      <!-- <vs-row id="center">
        <h6 class="font-weight-bold fontSizeData">Parts:</h6>
        <vs-spacer />
        <vs-button
          icon="settings"
          size="small"
          v-b-modal.modalTempParts
          class="rounded-pill"
          color="primary"
          type="filled"
          >Add Part</vs-button
        >
      </vs-row>
      --> 
      <br />

      <vs-row id="center">
        <h6 class="font-weight-bold fontSizeData">Details:</h6>
        <vs-spacer />
        <vs-button
          icon="settings"
          size="small"
          v-b-modal.modalAddParts
          class="rounded-pill mr-2"
          color="primary"
          type="filled"
          v-if="role == 'admin' && !['Closed'].includes(viewwork.status)"
          >Add Part</vs-button
        >

        <vs-button
          icon="edit"
          size="small"
          v-if="
            role == 'admin' &&
            ![
              'Submitted',
              'Approved',
              'Rejected',
              'Declined',
              'Cancelled',
            ].includes(viewwork.response)
          "
          v-b-modal.modalTempEdit
          class="rounded-pill"
          color="warning"
          type="filled"
          >Edit</vs-button
        >
      </vs-row>
      <br />
      <div>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Type</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                v-model="viewwork.type"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Status</span>
              <vs-input
                disabled="true"
                placeholder="Placeholder"
                class="selectVS mt-1"
                v-model="viewwork.iscomplete"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">WO Name</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.name"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Priority</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.priority"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">#</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.id"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Asset</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.asset"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Assignee</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.username"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">E-mail</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.email"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Start Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                v-model="viewwork.plandate"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual Start Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.startdate"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Due Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.duedate"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual End Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.finishtime"
              />
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-if="viewwork.detail != ''" class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Instruction</span><br />
              <div class="textAreaBox mt-2">{{ viewwork.detail }}</div>
            </div>
          </vs-col>
        </vs-row>

        <!-- <span class="detail">Attachments:</span>
        -->

        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Attachments:</span><br />
            </div>
          </vs-col>
        </vs-row>
        <vs-row
          style="display: inline-flex; flex-wrap: wrap"
          v-viewer="{ movable: false }"
          class="images mb-4"
        >
          <div
            class="img-wraps"
            style="margin: 12px"
            :id="'item-image-' + src"
            v-for="src in images"
            :src="src"
            :key="src"
          >
            <vs-icon
              icon="edit"
              class="edit"
              @click="editImage(src)"
              size="17px"
              color="success"
            ></vs-icon>
            <vs-icon
              icon="clear"
              class="closes"
              @click="remove(src)"
              size="17px"
              color="success"
            ></vs-icon>
            <img
              class="img-responsive"
              style="width: 150px; height: 150px"
              :src="src"
            /><br />
            <!-- <span class="detail">Comments:</span><br /> -->
          </div>
        </vs-row>

        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <vs-row style="align-items: center">
                <span class="detail">Comments:</span> <vs-spacer />
              </vs-row>
              <pre>{{ filteredList }}</pre>
              <!-- <pre>{{comments}}</pre> -->
              <div>
                <div
                  v-for="(i, index) in filteredList"
                  :key="index"
                  style="padding: 5px; display: flex"
                >
                  <div class="mt-2">
                    <vs-avatar color="success" :text="i.username" />
                  </div>
                  <div class="textAreaComment mt-2">
                    <vs-row class="mb-1"
                      ><span class="headComment colorSuccess">
                        {{ i.username }} </span
                      ><vs-spacer />{{
                        $moment(i.timestamp).format("YYYY-MM-DD HH:mm:ss")
                      }}
                      <vs-dropdown
                        v-if="
                          ![
                            'Submitted',
                            'Approved',
                            'Rejected',
                            'Declined',
                            'Cancelled',
                          ].includes(viewwork.response)
                        "
                        vs-trigger-click
                        class="cursor-pointer"
                      >
                        <a class="text-dark" href="#">
                          <span>
                            <vs-icon
                              icon="more_vert"
                              id="allIcon"
                              color="black"
                            ></vs-icon>
                          </span>
                        </a>
                        <vs-dropdown-menu class="topbar-dd fontSizeData">
                          <vs-dropdown-item
                            @click="
                              editItemMLR(index), (activeEdit = !activeEdit)
                            "
                          >
                            <span
                              ><vs-icon
                                icon="edit"
                                id="allIcon"
                                class="mr-2"
                              ></vs-icon></span
                            >Edit</vs-dropdown-item
                          >
                          <vs-dropdown-item @click="delItemMLR(index)">
                            <span
                              ><vs-icon
                                icon="delete"
                                id="allIcon"
                                class="mr-2"
                              ></vs-icon></span
                            >Delete</vs-dropdown-item
                          ></vs-dropdown-menu
                        ></vs-dropdown
                      >
                    </vs-row>
                    <span class="mt-1" :id="'item-comment-' + index">{{
                      i.comment
                    }}</span>
                    <!-- <div v-if="i.location" class="mt-3"> -->
                    <!-- <div v-for="(data,index) in i.files" :key="index" style="display: inline-flex; flex-wrap: wrap" class="mt-1">
                      <div class="mr-2"><img
                        class="img-responsive"
                        style="width: 100px; height: 100px"
                        :src="data.location"
                      /></div>
                      
                    </div> -->

                    <vs-row
                      style="display: inline-flex; flex-wrap: wrap"
                      v-viewer="{ movable: false }"
                      class="images"
                    >
                      <div
                        class="img-wraps mr-2 mt-1"
                        style="margin: 0px"
                        :id="'item-image-' + key"
                        v-for="(data, index) in i.files"
                        :key="index"
                      >
                        <vs-icon
                          icon="edit"
                          class="edit"
                          @click="editImage(data)"
                          size="17px"
                          color="success"
                        ></vs-icon>
                        <vs-icon
                          icon="clear"
                          class="closes"
                          @click="remove(data)"
                          size="17px"
                          color="success"
                        ></vs-icon>
                        <img
                          class="img-responsive"
                          style="width: 100px; height: 100px"
                          :src="data.location"
                        /><br />
                      </div>
                    </vs-row>

                    <div :id="'item-user-' + index" style="display: none">
                      <vs-textarea
                        class="widthTextArea mt-1"
                        style="margin-bottom: 2px"
                        placeholder="Write a message..."
                        v-model="i.comment"
                      />
                      <vs-col vs-type="flex" vs-align="center" vs-w="12">
                        <vs-spacer />
                        <vs-button
                          class="rounded-pill"
                          color="dark"
                          size="small"
                          type="flat"
                          @click="cancelEditComment(index)"
                          >Cancel</vs-button
                        >
                        <vs-button
                          color="success"
                          size="small"
                          class="rounded-pill ml-2"
                          @click="editData(i, index)"
                          type="filled"
                          >Save</vs-button
                        >
                      </vs-col>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="activeComment == false"
                style="padding: 5px; align-items: center; display: flex"
              >
                <vs-spacer />
                <vs-tooltip text="Add a Comment" position="left">
                  <vs-button
                    v-if="
                      ![
                        'Submitted',
                        'Approved',
                        'Rejected',
                        'Declined',
                        'Cancelled',
                      ].includes(viewwork.response)
                    "
                    icon="question_answer"
                    size="small"
                    @click="activeComment = !activeComment"
                    class="rounded-pill"
                    color="success"
                    type="filled"
                    >Add Comment</vs-button
                  >
                </vs-tooltip>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row v-if="activeComment == true" class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <vs-textarea
                class="widthTextArea mt-1"
                style="margin-bottom: 2px"
                placeholder="Add a comment..."
                v-model="valueComment"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box mt-1 container-fluid">
              <vs-row vs-align="center">
                <span class="detail mr-2">Upload File</span>
                <vs-button
                  style="border-radius: 20px"
                  icon="cloud_upload"
                  size="small"
                  v-if="showUpload == false"
                  color="primary"
                  @click="showUpload = !showUpload"
                  type="border"
                  >Select File</vs-button
                ></vs-row
              >
              <UploadImages
                v-if="showUpload == true"
                class="mt-2"
                style="padding: 5px"
                @changed="handleImagesCom"
              />
            </div>
          </vs-col>

          <vs-row style="padding: 5px; align-items: center; display: flex">
            <vs-col vs-type="flex" vs-align="center" vs-w="12">
              <vs-spacer />
              <vs-button
                class="rounded-pill"
                color="dark"
                type="flat"
                size="small"
                @click="cancelAddComment"
                >Cancel</vs-button
              >
              <vs-button
                color="success"
                class="rounded-pill ml-2"
                size="small"
                @click="pushData(valueComment, viewwork)"
                type="filled"
                >Submit</vs-button
              >
            </vs-col>
          </vs-row>
        </vs-row>

        <vs-row
          v-if="
            role == 'admin' &&
            ['Approved', 'Rejected'].includes(viewwork.response)
          "
          class="mb-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <div>
              <div style="text-align: center">
                <h5 style="font-weight: 500">What's Your Rate</h5>
              </div>

              <div class="stars">
                <form id="starForm" action="">
                  <input
                    class="star star-5"
                    id="star-5"
                    type="radio"
                    name="star"
                    value="5"
                    @change="getInputValue"
                  />
                  <label class="star star-5" for="star-5"
                    ><div class="textRating">5</div></label
                  >
                  <input
                    class="star star-4"
                    id="star-4"
                    type="radio"
                    name="star"
                    value="4"
                    @change="getInputValue"
                  />
                  <label class="star star-4" for="star-4"
                    ><div class="textRating">4</div></label
                  >
                  <input
                    class="star star-3"
                    id="star-3"
                    type="radio"
                    name="star"
                    value="3"
                    @change="getInputValue"
                  />
                  <label class="star star-3" for="star-3"
                    ><div class="textRating">3</div></label
                  >
                  <input
                    class="star star-2"
                    id="star-2"
                    value="2"
                    type="radio"
                    name="star"
                    @change="getInputValue"
                  />
                  <label class="star star-2" for="star-2"
                    ><div class="textRating">2</div></label
                  >
                  <input
                    class="star star-1"
                    id="star-1"
                    type="radio"
                    value="1"
                    name="star"
                    @change="getInputValue"
                  />
                  <label class="star star-1" for="star-1"
                    ><div class="textRating">1</div></label
                  >
                </form>
              </div>
              <div style="text-align: center">
                <h5 style="font-weight: 500">{{ John }}</h5>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row v-if="viewwork.response == 'Acknowledged'" class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Completion Notes</span>

              <vs-textarea class="widthTextArea mt-1" v-model="compleNote" />
              <!-- <vs-button
                icon="done"
                v-if="role != 'admin'"
                size="small"
                @click="complete"
                class="rounded-pill"
                color="success"
                type="filled"
                >Submit</vs-button
              > -->
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>

    <!-- Modal for delete -->
    <b-modal id="modal-cmdelete" ref="modal-cmdelete" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Comment</b
        >
      </template>
      <p class="my-4">Are you sure you would like to delete this comment?</p>
      <template #modal-footer="{}">
        <vs-button
          style="border-radius: 20px"
          color="dark"
          type="flat"
          @click="hideModal"
        >
          Cancel
        </vs-button>
        <vs-button
          v-if="role == 'admin'"
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="acceptCommentDelete()"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>

    <b-modal
      id="modal-comment"
      ref="modalComment"
      no-close-on-backdrop="false"
      size="xl"
    >
      <template #modal-title>
        <h5 style="color: #32c040">Add Comment</h5>
      </template>
      <!-- <span class="my-4">Please enter what you would like to say</span> -->
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="12">
          <div class="input-box container-fluid">
            <span class="detail">Please enter what you would like to say</span>
            <!-- <div>
              <vs-textarea  height="400px" />
            </div> -->
            <textarea
              v-model="valueComment"
              style="
                resize: none;
                margin-top: 5px;
                width: 100%;
                border-radius: 6px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                overflow-y: auto;
                padding: 10px;
                font-size: 0.75rem;
                height: 250px;
              "
            ></textarea>
          </div>
        </vs-col>
      </vs-row>
      <!-- <vs-row class="mb-1" vs-w="12">
        <vs-col
          class="mt-1 mb-1"
          vs-type="flex"
          style="font-size: 0.75rem"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <span class="mt-3">Upload file :</span>
          <vs-input
            class="ml-2"
            style="width: 330px"
            type="file"
            description-text="Supported file extensions : .jpg , .jpeg , .png "
            ref="file"
            accept="image/*"
            @change="FileSelect1"
          />
        </vs-col>
      </vs-row> -->
      <template #modal-footer>
        <vs-button
          @click="submitComment(valueComment)"
          class="brdbtn"
          color="success"
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          type="flat"
          @click="cancelComment"
          >Close</vs-button
        >
      </template>
    </b-modal>
    <b-modal
      id="modalTempEdit"
      ref="modalTempEdit"
      scrollable
      no-close-on-backdrop="false"
      hide-header-close
      size="xl"
    >
      <template #modal-title>
        <h5 style="color: rgb(255, 145, 30)">Edit Work Order</h5>
      </template>
      <div class="container">
        <!-- <pre> {{ viewwork }}</pre> -->
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Type</span>
              <vs-row class="mt-3 selectVS">
                <input
                  class="mr-1"
                  type="radio"
                  id="one"
                  value="false"
                  v-model="viewwork.type"
                />
                <label class="mr-4" for="one">Unplanned</label>
                <input
                  class="mr-1"
                  type="radio"
                  id="two"
                  value="true"
                  v-model="viewwork.type"
                />
                <label for="two">Planned</label></vs-row
              >
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Status</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                v-model="viewwork.iscomplete"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">WO Name</span>
              <vs-input
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.name"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Priority</span>
              <vs-select class="selectVS mt-1" v-model="viewwork.priority">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in optionsPriority"
                />
              </vs-select>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">#</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.id"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Asset</span>
              <vs-input
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.asset"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Assignee</span>
              <vs-select
                class="selectVS mt-1"
                @change="onChange(viewwork.username)"
                v-model="viewwork.username"
              >
                <vs-select-item
                  :key="index"
                  :value="item.username"
                  :text="item.username"
                  v-for="(item, index) in workerlist"
                />
              </vs-select>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">E-mail</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.email"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Start Date</span>
              <div class="selectVS mt-1">
                <VueCtkDateTimePicker
                  position="bottom"
                  style="heigth: 15px"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="viewwork.plandate"
                ></VueCtkDateTimePicker>
              </div>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual Start Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.startdate"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Due Date</span>
              <div class="selectVS mt-1">
                <VueCtkDateTimePicker
                  position="bottom"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="viewwork.duedate"
                ></VueCtkDateTimePicker>
              </div>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual End Date</span>
              <vs-input
                disabled="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="viewwork.finishtime"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Instructions</span><br />
              <vs-textarea class="widthTextArea" v-model="viewwork.detail" />
            </div>
          </vs-col>
        </vs-row>
      </div>
      <template #modal-footer>
        <vs-button
          @click="submitEdit(viewwork)"
          class="brdbtn"
          color="success"
          type="filled"
          >Submit</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat" @click="cancelEdit"
          >Close</vs-button
        >
      </template>
    </b-modal>
    <!-- Edit Work Order -->
    <b-modal
      id="modal-EditImge"
      ref="modalEditImge"
      hide-footer
      no-close-on-backdrop="false"
      size="xl"
    >
      <template #modal-title>
        <h5 style="color: rgb(255, 145, 30)">Edit Work Order</h5>
      </template>
      <template>
        <div>
          <div class="con-tab-ejemplo">
            <vs-table
              multiple
              v-model="selected"
              pagination
              max-items="10"
              search
              :data="partList"
            >
              <template slot="header">
                <h4>Select parts needed for this work order</h4>
                <!-- {{ viewwork }}55 -->
                <!-- <Pre>{{selected}}</Pre> -->
              </template>
              <template slot="thead">
                <vs-th sort-key="email"> Part Name </vs-th>
                <vs-th sort-key="username"> Qty </vs-th>
                <vs-th sort-key="website"> Cost </vs-th>
                <vs-th sort-key="website"> Pick </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].part_name">
                    {{ data[indextr].partname }}
                  </vs-td>

                  <vs-td :data="data[indextr].qty">
                    {{ data[indextr].qtycurrent }}
                  </vs-td>

                  <b-modal
                    id="modal-Sign"
                    ref="modalSign"
                    no-close-on-backdrop="false"
                    size="lg"
                  >
                    <template #modal-title>
                      <h5 style="color: rgb(255, 145, 30)">Edit Work Order</h5>
                    </template>
                    <vs-row
                      ><vs-spacer />
                      <vs-button
                        @click="isEmpty"
                        color="success"
                        type="flat"
                        style="border-radius: 20px"
                        >Clear signature</vs-button
                      > </vs-row
                    ><button @click="deleteImg">clear</button>
                    <button @click="getSignature">get signature</button>
                    <vs-row vs-w="12">
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <vue-signature
                          :width="width"
                          :height="height"
                          ref="s1"
                        />
                      </vs-col>
                    </vs-row>
                    <template #modal-footer>
                      <vs-button class="brdbtn" color="success" type="filled"
                        >Appove</vs-button
                      >
                      <vs-button class="brdbtn" color="dark" type="flat"
                        >Cancel</vs-button
                      >
                    </template>
                  </b-modal>

                  <vs-td :data="data[indextr].Pick">
                    <vs-input
                      type="number"
                      min="0"
                      :max="data[indextr].qtycurrent"
                      class="inputx mt-1"
                      style="width: 50%"
                      placeholder="Enter Qty"
                      v-model="data[indextr].qtypart"
                      @change="totalcost(selected)"
                    />
                    <!--PP -->
                    <!-- <vs-input-number :is-disabled="true" min="0" :max="data[indextr].qtycurrent"  v-model="data[indextr].qtypart"/> -->
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div style="text-align: end" class="mr-2">
              <p>{{ sumpart }} parts | ฿ {{ sumcost }}</p>
            </div>

            <!-- <div
                  v-for="item in selected"
                  :key="item"
                  style="padding-bottom: 1%"
                >
                  <vs-row class="ml-5">
                    <vs-input
                      class="inputx mt-1"
                      placeholder="Placeholder"
                      v-model="item.part_name"
                      disabled
                    />
                    <div class="ml-4">
                      <vs-input-number
                        color="success"
                        v-model="qtypart"
                        min="0"
                      />
                    </div>
                  </vs-row>
                </div> -->
          </div>

          <b-modal
            id="modalTempParts"
            ref="modalTempParts"
            hide-header-close
            no-close-on-backdrop="false"
            size="xl"
          >
            <template #modal-title>
              <h5 style="color: rgb(50, 192, 64)">Add Part</h5>
            </template>
            <addParts :selectedPart="selectedPart" />

            <template #modal-footer>
              <vs-button class="brdbtn" color="success" type="filled"
                >Appove</vs-button
              >
              <vs-button
                class="brdbtn"
                @click="closeModalParts"
                color="dark"
                type="flat"
                >Cancel</vs-button
              >
            </template>
          </b-modal>
        </div>
      </template></b-modal
    >
  </div>
</template>

<script>
import addParts from "../dashboard/Workorder/Modal/addParts.vue";
import ImageEditor from "../dashboard/Workorder/Modal/ImageEditor.vue";
import UploadImages from "vue-upload-drop-images";
import stepperWO from "../dashboard/Workorder/stepperWO.vue";
import stepbar from "../dashboard/Workorder/Modal/stepbar.vue";
import EditWorkOrder from "../dashboard/Workorder/Modal/EditWorkOrder​.vue";
import { FormRenderer } from "v-form-builder";
import { VueEditor } from "vue2-editor";
export default {
  name: "",
  components: {
    VueEditor,
    FormRenderer,
    EditWorkOrder,
    stepperWO,
    stepbar,
    UploadImages,
    ImageEditor,
    addParts,
  },
  props: {
    viewwork: Array,
    dataPrint: Array,
    updateData: Array,
    workerlist: Array,
    filterPriority: Array,
    cancelReload: Function,
  },
  data: () => ({
    selectedPart: "aaaaa",
    signature: "",
    width: "400px",
    height: "200px",
    headerBgVariant: "dark",
    John: "",
    imagesData: [],
    images: [
      "https://picsum.photos/200/200",
      "https://www.sentenance.com/wp-content/uploads/2021/07/factory-02.png",
      "https://picsum.photos/250/200",
      "https://www.sentenance.com/wp-content/uploads/2021/07/factory-03.png",
      "https://www.sentenance.com/wp-content/uploads/2021/07/building-02.png",
    ],
    showUpload: false,
    valueComment: "",
    activeComment: false,
    activeEdit: false,
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
    ],
    role: "",
    accessToken: "",
    getAction: [],
    compleNote: "",
    dataPrint: [],
    dataViewwork: [],
    nameValue: "",
    viewpercentage: 0,
    formData: "",
    activePrompt: false,
    optionEdit: false,
    content: "",
    select1: 2,
    optionsPriority: [
      { text: "1 - Low Priority", value: "1 - Low priority" },
      { text: "2 - Medium Priority", value: "2 - Medium priority" },
      { text: "3 - High Priority", value: "3 - High priority" },
    ],
    select2: 7,
    idWO: "",
    dataa: [],
    username: "",
    comments: [],
    // comments: [
    //   {
    //     id: null,
    //     work_id: null,
    //     comment: null,
    //     username: null,
    //     timestamp: null,
    //   },
    // ],
    // optionsPriority: [
    //   { text: "1 - Low Priority", value: 1 },
    //   { text: "2 - Medium Priority", value: 2 },
    //   { text: "3 - High Priority", value: 3 },
    // ],
    editOffset: -1,
    editPost: {},
    editPostOri: {},
    getResponseST: [],
    resprintCreated: [],
    resprintAcknowledged: [],
    resprintSubmitted: [],
    resprintRejected: [],
    resprintDeclined: [],
    resprintApproved: [],
    resprintCancelled: [],
    dataPrint: [],
    text: "",
    imageArrayCom: [],
    ratingValue: "",
    signPhoto: "",
    message: "Hello Vue!",
    vueCanvas: null,
    painting: false,
    canvas: null,
    ctx: null,
    sumpart: 0,
    sumcost: 0,
  }),
  methods: {
    totalcost(data) {
      this.sumpart = 0;
      this.sumcost = 0;
      data.forEach((e) => {
        this.sumpart += parseInt(e.qtypart);
        this.sumcost += e.qtypart * e.price;
      });
    },
    GetPartList() {
      console.log("res");
      this.$API.get("parts").then((res) => {
        console.log(res.data.result);
        this.partList = res.data.result;
      });
    },
    deleteImg() {
      this.$refs.s1.clear();
      this.signature = "";
    },
    isEmpty() {
      if (this.$refs.s1.isEmpty()) {
        alert("Empty");
      } else {
        alert("No");
      }
    },
    startPainting(e) {
      this.painting = true;
      console.log(this.painting);
      this.draw(e);
    },
    finishedPainting() {
      this.painting = false;
      console.log(this.painting);
      this.ctx.beginPath();
    },
    draw(e) {
      if (!this.painting) return;

      this.ctx.lineWidth = 5;
      this.ctx.lineCap = "round";

      this.ctx.lineTo(e.clientX, e.clientY);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(e.clientX, e.clientY);
    },
    resizeCanvas() {
      // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
      this.signPhoto = data;
    },
    getInputValue() {
      var form = document.getElementById("starForm");
      this.ratingValue = form.elements["star"].value;
      console.log(this.ratingValue);
      // console.log(`work/${this.viewwork.id}/feedback`)
      let body = {
        score: this.ratingValue,
      };
      this.$API
        .post(`work/${this.viewwork.id}/feedback`, body)
        .then((result) => {
          console.log(result);
        });
    },
    show2() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
    remove(item) {
      var el = document.getElementById("item-image-" + item);
      el.remove();
      // this.images.splice(item, 1);
    },
    closeeditImage() {
      this.$refs["modalEditImge"].hide();
      this.imagesData = [];
    },
    editImage(item) {
      this.imagesData = [];
      this.$refs["modalEditImge"].show();
      this.imagesData = item;
      console.log(item);
    },
    printTemplate(item) {
      this.$session.set("dataPrint", item);
      this.$router.push({
        name: "printTemplate",
        params: {
          dataPrint: item,
        },
      });
    },
    editData(data, item) {
      console.log(data, item);
      let body = {
        comment: data.comment,
      };
      this.$API
        .put(`work/${this.viewwork.id}/comment/${data.id}`, body)
        .then((result) => {
          this.$vs.notify({
            title: "Success",
            color: "success",
            text: "comment edited",
            position: "top-center",
          });
          document.getElementById("item-comment-" + item).style.display =
            "block";
          document.getElementById("item-user-" + item).style.display = "none";
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
        });
    },
    cancelEditComment(item) {
      document.getElementById("item-comment-" + item).style.display = "block";
      document.getElementById("item-user-" + item).style.display = "none";
    },
    editItemMLR(item) {
      document.getElementById("item-comment-" + item).style.display = "none";
      document.getElementById("item-user-" + item).style.display = "block";

      // document.getElementById("item-user-" + item).focus();
      // this.$nextTick(
      //   function () {
      //     console.log("item-user-" + item);
      //     document.getElementById("item-user-" + item).focus();
      //   }.bind(this)
      // );
    },
    delItemMLR(item) {
      let comment_id = this.comments[item].id;
      this.$API
        .delete(`work/${this.viewwork.id}/comment/${comment_id}`)
        .then((result) => {
          this.comments.splice(item, 1);
          this.$vs
            .notify({
              title: "Deleted",
              color: "success",
              position: "top-center",
            })
            .cathc((error) => {
              this.$vs.notify({
                title: "Error",
                text: err.response.data.error,
                color: "danger",
                position: "top-center",
              });
            });
        });
      // this.$delete(this.filteredList, item);
      // this.$delete(this.comments, item + 1);
      // Delete value of index from filter
    },
    handleImagesCom(files) {
      // this.imageArrayCom = [];
      // this.imageArrayCom.push(files);
      this.imageArrayCom = files;
      console.log(this.imageArrayCom);
      // console.log(this.imageArrayCom);
      /*
                  [
                    {
                        "name": "Screenshot from 2021-02-23 12-36-33.png",
                        "size": 319775,
                        "type": "image/png",
                        "lastModified": 1614080193596
                        ...
                    },
                    ...
                    ]
                 */
    },
    // pushData() {
    //   console.log(this.imageArrayCom[0]);
    //   let body = {
    //     comment: this.valueComment,
    //   };
    //   if (!this.imageArrayCom.length) {
    //     this.$API
    //       .post(`work/${this.viewwork.id}/comment`, body)
    //       .then((result) => {
    //         console.log(result);
    //         this.comments.push({
    //           id: result.data[0].id,
    //           work_id: this.viewwork.id,
    //           comment: result.data[0].comment,
    //           username: this.username,
    //           timestamp: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    //         });
    //         this.$vs.notify({
    //           title: "Success",
    //           color: "success",
    //           position: "top-center",
    //         });
    //       });
    //   } else {
    //     this.imageArrayCom[0].forEach((file) => {
    //       let body = {
    //         comment: this.valueComment,
    //         file: file,
    //       };
    //       this.$API
    //         .post(`work/${this.viewwork.id}/images`, body)
    //         .then((result) => {
    //           console.log(result);
    //           if (result) console.log(result);
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     });
    //   }

    //   this.activeComment = false;
    //   this.valueComment = [];
    //   console.log(this.filteredList);
    // },
    pushData() {
      if (!this.imageArrayCom.length && this.valueComment.length) {
        let body = {
          comment: this.valueComment,
        };
        this.$API
          .post(`work/${this.viewwork.id}/comment`, body)
          .then((result) => {
            // if (result.data[0].comment == null) {
            //   this.activeComment = false;
            // } else {
            console.log(result);
            this.comments.push({
              id: result.data[0].id,
              work_id: this.viewwork.id,
              comment: result.data[0].comment,
              username: this.username,
              timestamp: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
            });
            this.$vs.notify({
              title: "Success1",
              color: "success",
              position: "top-center",
            });
            // }
          });
      } else {
        var formData = new FormData();
        formData.append("comment", this.valueComment);
        this.imageArrayCom.forEach(async (file) => {
          await formData.append("file", file);
        });
        console.log(formData);
        this.$API
          .post(`work/${this.viewwork.id}/comment/images`, formData)
          .then((result) => {
            if (result) console.log(result);
            this.comments.push({
              work_id: this.viewwork.id,
              comment: result.data.comment,
              username: this.username,
              files: result.data.files,
              timestamp: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }

      this.activeComment = false;
      this.valueComment = [];
      console.log(this.filteredList);
    },
    cancelAddComment() {
      this.activeComment = false;
      this.showUpload = false;
      this.valueComment = [];
    },
    closeModalParts() {
      this.$refs["modalTempParts"].hide();
    },
    submitComment(item) {
      // console.log(item);
      this.$refs["modalComment"].hide();
      // $('#myModal').modal('hide')
    },
    submitEdit(item) {
      let body = {
        data: item,
      };
      this.$API
        .post("work/" + item.id + "/edit", body)
        .then((result) => {
          console.log(result);
          this.$vs.notify({
            title: "Success",
            color: "success",
            position: "top-center",
          });
          this.$refs["modalTempEdit"].hide();
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    modalDelComment(item) {
      this.$refs["modal-cmdelete"].show();
      console.log(item);
    },
    acceptCommentDelete() {},
    hideModal() {
      this.$refs["modal-cmdelete"].hide();
    },
    declineTask(item) {
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/decline`, body)
        .then((result) => {
          this.$vs.notify({
            title: "Declined",
            text: "Work order has been declined",
            color: "success",
            position: "top-center",
          });
          setTimeout(() => {
            // location.reload();
            item.response = "Decline";
            this.cancelReload();
          }, 1000);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
    },
    cancelledTask(item) {
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/cancel`, body)
        .then((result) => {
          console.log(result.data);
          if (result.data)
            this.$vs.notify({
              title: "Cancelled",
              text: "Work order has been  cancelled",
              color: "success",
              position: "top-center",
            });
          setTimeout(() => {
            item.response = "Cancelled";
            item.iscomplete = "Closed";
            this.cancelReload();
            // location.reload();
          }, 1000);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
      // // Status : Closed
      // // Response : Approved
    },
    signFOrAppoveTask() {
      this.$refs["modalSign"].show();
    },
    approveTask(item) {
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/approve`, body)
        .then((result) => {
          console.log(result.data);
          if (result.data)
            this.$vs.notify({
              title: "Approved",
              text: "Work order has been approved",
              color: "success",
              position: "top-center",
            });
          setTimeout(() => {
            item.response = "Approved";
            item.iscomplete = "Closed";
            this.cancelReload();
          }, 1000);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
      // // Status : Closed
      // // Response : Approved
    },
    rejectTask(item) {
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/reject`, body)
        .then((result) => {
          if (result) {
            this.$vs.notify({
              title: "Rejected",
              text: "Work order has been rejected",
              color: "success",
              position: "top-center",
            });
            setTimeout(() => {
              // location.reload();
              item.response = "Rejected";
              item.iscomplete = "Closed";
              this.cancelReload();
            }, 1000);
          }
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
    },
    acknowledgeTask(item) {
      if (!item.comment) item.comment = null;
      let body = {
        comment: item.comment,
      };
      this.$API
        .put(`work/${item.id}/acknowledge`, body)
        .then((result) => {
          this.$vs.notify({
            title: "Acknowledged",
            text: "Work order has been acknowledged",
            color: "success",
            position: "top-center",
          });
          setTimeout(() => {
            item.response = "Acknowledged";
            this.cancelReload();
            // this.$emit('cancelReload');
            // location.reload();
          }, 1000);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Error",
            text: err.response.data.error,
            color: "danger",
            position: "top-center",
          });
          console.log(err.response.status);
          console.log(err.response.data);
        });
    },
    cancelComment() {
      this.$refs["modalComment"].hide();
    },
    cancelEdit() {
      this.$refs["modalTempEdit"].hide();
    },
    saveEdit() {
      console.log(this.updateData);
      this.$http
        .post(this.$url2 + "editwork", {
          data: this.updateData,
        })
        .then(() => {
          // location.reload();
        });
    },
    onChange(item) {
      console.log(item);
      this.workerlist.forEach((value) => {
        if (this.updateData.username == value.name) {
          console.log(value.email);
          this.updateData.email = value.email;
        }
      });
    },
    setArray() {
      this.viewwork = [];
    },
    printmodal() {
      const modal = document.getElementById("print1");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      return false;
      // this.viewwork = [];
    },
    cancel() {
      location.reload();
    },
    complete2() {
      // console.log(this.viewwork.id);
      const body = {
        id: this.viewwork.id,
        username: this.viewwork.username,
        status: "true",
      };
      this.$API
        .post("updateworkstatus", body)
        .then((result) => {
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Updated",
              text: "Your work order has been updated",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            location.reload(1);
          }, 1000);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      console.log(body);
    },
  },
  mounted() {
    this.role = this.$session.get("role");
    this.accessToken = this.$session.get("accessToken");
    this.username = this.$session.get("username");
    console.log(
      this.$url2 + "work/" + this.viewwork.id + "/reject/" + this.accessToken
    );
    this.$API
      .get(
        this.$url2 + "work/" + this.viewwork.id + "/reject/" + this.accessToken
      )
      .then((result) => {
        console.log(result);
        // result.data;
      });
    // this.viewwork = this.$session.get("viewwork");
    this.dataPrint = this.$session.get("dataPrint");
    console.log("mounting table");
    this.viewpercentage = 0;
    var maxitem = 0;
    var nullitem = 0;
    var item = this.viewwork;
    console.log(item);
    this.formData = item.form;
    this.activePrompt = true;
    setTimeout(() => {
      this.formInputData = item.inputdata;
      console.log(this.formInputData);
      if (item.inputdata) {
        Object.keys(item.inputdata).forEach((element) => {
          maxitem += 1;
          if (
            item.inputdata[element] == null ||
            item.inputdata[element] == 0 ||
            item.inputdata[element] == ""
          ) {
            nullitem += 1;
          }
        });
        this.viewpercentage = ([(maxitem - nullitem) / maxitem] * 100).toFixed(
          2
        );
      }
    }, 200);

    console.log(this.viewwork);
    // //Comment
    console.log(`work/${this.viewwork.id}/comment`);
    this.$API.get(`work/${this.viewwork.id}/comment`).then((result) => {
      console.log(result.data);
      this.comments = result.data;
      console.log(this.comments);
    });
    this.canvas = document.getElementById("canvas");
    this.ctx = canvas.getContext("2d");

    // Resize canvas
    this.canvas.height = window.innerHeight;
    this.canvas.width = window.innerWidth;
  },
  beforeDestroy() {
    this.viewwork = [];
  },
  computed: {
    filteredList() {
      return this.comments.filter((post) => {
        return post.username != null && post.timestamp != null;
      });
    },
  },
};
</script>
<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    position: absolute;
    left: 0;
    top: 0;
    /* background-color: pink; */
  }
}
</style>

<style scoped>
#canvas {
  width: 100%;
  height: 100%;
  border: 1px solid black;
  border-radius: 20px;
}
.headComment {
  font-weight: 400;
}
.textRating {
  font-size: 0.75rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 400;
}
div.stars {
  width: 270px;
  /* display: inline-block; */
}

input.star {
  display: none;
}

label.star {
  float: right;
  padding: 10px;
  font-size: 36px;
  color: #444;
  transition: all 0.2s;
}

input.star:checked ~ label.star:before {
  content: "★";
  color: #fd4;
  transition: all 0.25s;
}

/* input.star-5:checked ~ label.star:before {
  color:#FE7;
  text-shadow: 0 0 20px #952;
} */

input.star-1:checked ~ label.star:before {
  color: #f62;
}

/* label.star:hover {
  transform: rotate(-15deg) scale(1.3);
} */

label.star:before {
  content: "✰";
  color: #fd4;
  transition: all 0.25s;
}

.rev-box {
  overflow: hidden;
  height: 0;
  width: 100%;
  transition: all 0.25s;
}

textarea.review {
  background: #222;
  border: none;
  width: 100%;
  max-width: 100%;
  height: 100px;
  padding: 10px;
  box-sizing: border-box;
  color: #eee;
}

label.review {
  display: block;
  transition: opacity 0.25s;
}

input.star:checked ~ .rev-box {
  height: 125px;
  overflow: visible;
}
.img-wraps {
  position: relative;
  display: inline-block;
}
.img-wraps .closes {
  position: absolute;
  visibility: hidden;
  top: 17px;
  right: 18px;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps:hover .closes {
  opacity: 1;
  visibility: visible;
  color: #32c040;
}
.img-wraps:hover .edit {
  opacity: 1;
  visibility: visible;
  color: palevioletred;
}
.img-wraps .edit {
  position: absolute;
  visibility: hidden;
  top: 17px;
  right: 38px;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}

.marginTop {
  margin-top: 3px;
}
.aLocation:hover {
  /* background-color: yellow; */
  color: #32c040;
  border-bottom: 1px solid #32c040;
  cursor: pointer;
}
.aLocation {
  /* background-color: yellow; */
  color: #32c040;
  cursor: pointer;
}
.brdbtn {
  width: 80px;
  border-radius: 20px;
}
/* *{
  margin:0;
  padding:0;
  box-sizing: border-box;
}
body{ 
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items:center;
  padding: 10px;
}
.container{
  max-width: 700px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.container form .user-detail{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
form .user-detail .vs-select .vs-input{
  margin: 20px 0 12px 0;
  width: calc(100% / 2 - 10%);
}
.user-detail .vs-input .vs-select {
  height: 200px;
  width: 100%;
}
.user-detail .vs-select .vs-input .details {
  font-weight: 500px;
  margin-bottom: 5px;
}
.selectVS{
  width: 250px;
} */
.notiApproval {
  background: #e3fadd;
  border-color: #8bed84;
}
.notiAcknow {
  background: #ffeedb;
  border-color: #edcc84;
}
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  padding: 0;
}
.selectVS {
  width: 75%;
  font-size: 0.75rem;
  white-space: nowrap;
}
.widthTextArea {
  width: 99.3%;
}
.textAreaBox {
  display: block;
  width: 99%;
  font-size: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.8);
  padding: 9px;
  overflow: hidden;
  min-height: 40px;
  line-height: 20px;
}
.textAreaComment {
  display: block;
  overflow-wrap: break-word;
  width: 100%;
  font-size: 0.75rem;
  align-items: center;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.8);
  padding: 9px;
  overflow: hidden;
  min-height: 40px;
  line-height: 20px;
}
.detail {
  font-size: 0.75rem;
  font-weight: 500;
}
.inputData {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
#btnShare {
  color: #111111;
  border-radius: 20px;
  display: inline-block;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
#center {
  text-align: center;
}
#allIcon {
  font-size: 16px;
}
.modal-open .modal {
  padding-right: 0px;
}
.p-0 {
  padding: 0;
}
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}

#editor1 {
  height: 350px;
  width: 900px;
}

.inputdes {
  width: 300px;
}
.c {
  width: 300px;
  border-radius: 100px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media screen and (max-width: 992px) {
  /* .container {
    background-color: yellowgreen;
  } */
  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding: 0;
  }
  form .user-detail .vs-select .vs-input {
    width: calc(100% / 2 - 20px);
  }
  .selectVS {
    width: 200px;
  }
  .textAreaBox {
    width: 98%;
  }
}
.b {
  /* background-color: cadetblue; */
  padding-left: 0;
}
.d {
  background-color: grey;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
@media screen and (max-width: 600px) {
  /* .container {
    background-color: yellowgreen;
  } */
  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding: 0;
  }
  form .user-detail .vs-select .vs-input {
    width: calc(100% / 2 - 20px);
  }
  .selectVS {
    width: 200px;
  }
  /* .textAreaBox {
    width: 100%;
  } */
}
</style>
